'use strict';

function ChangeDueDateController(
  $scope,
  $mdDialog,
  ids
) {
  $scope.ids = ids;
  $scope.save = function() {
    $mdDialog.hide({
      date: $scope.date,
    });
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}
ChangeDueDateController.$inject = [
  '$scope',
  '$mdDialog',
  'ids'
];

export default ChangeDueDateController;
